import React from "react";

interface PlaceholderPageProps {
	title: string;
	description?: string;
	children?: React.ReactNode;
}

/** Generic under-construction page component displaying a title, description and coming-soon message. */
const PlaceholderPage: React.FC<PlaceholderPageProps> = ({ title, description, children }) => (
	<div className="space-y-6">
		<section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
			<header className="space-y-2">
				<p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Work in progress</p>
				<h1 className="text-2xl font-semibold text-slate-900">{title}</h1>
				<p className="text-sm text-slate-500">{description ?? "This area will be implemented soon."}</p>
			</header>
			<div className="mt-6 flex flex-col items-start gap-3 rounded-xl border border-dashed border-slate-300 bg-slate-50 px-4 py-6 text-sm text-slate-500">
				<p>We are still building this experience.</p>
				<p>In the meantime, feel free to outline requirements or drop notes for the team.</p>
			</div>
		</section>
		{children}
	</div>
);

export default PlaceholderPage;

